import { defineComponent as r, computed as s, openBlock as d, createElementBlock as n, normalizeClass as m, renderSlot as c } from "vue";
import { tw as e } from "../../utils/tailwind.js";
const u = /* @__PURE__ */ r({
  name: "RevCard",
  __name: "Card",
  props: {
    hoverable: { type: Boolean }
  },
  setup(o) {
    const a = o, t = s(() => [
      e`bg-float-default-low shadow-short rounded-lg`,
      a.hoverable && e`focus-within:shadow-middle hover:bg-float-default-low-hover hover:shadow-middle`
    ]);
    return (l, p) => (d(), n("div", {
      class: m(t.value)
    }, [
      c(l.$slots, "default")
    ], 2));
  }
});
export {
  u as default
};
